<script setup>
import CrmColumn from './CrmColumn.vue';

const props = defineProps({
  pipeline: {
    type: Object,
    required: true,
  },
  conversationsByStage: {
    type: Object,
    required: true,
  },
  columnTotals: {
    type: Object,
    default: () => ({}),
  },
  getSlaInfo: {
    type: Function,
    required: true,
  },
  getChannelInfo: {
    type: Function,
    required: true,
  },
  getSourceInfo: {
    type: Function,
    required: true,
  },
  getTeamInfo: {
    type: Function,
    required: true,
  },
  getDealValue: {
    type: Function,
    required: true,
  },
  getDealStatus: {
    type: Function,
    required: true,
  },
  formatCurrency: {
    type: Function,
    required: true,
  },
  formatDateTime: {
    type: Function,
    required: true,
  },
});

const emit = defineEmits([
  'move-stage',
  'assign-me',
  'resolve',
  'update-deal-value',
  'update-deal-status',
  'rename-lead',
  'delete-card',
  'duplicate-card',
  'edit-card',
]);
</script>

<template>
  <main
    class="flex flex-1 gap-4 overflow-x-auto p-6 bg-n-surface-1 custom-scrollbar-x"
  >
    <CrmColumn
      v-for="stage in pipeline.stages"
      :key="stage.id"
      :stage="stage"
      :conversations="conversationsByStage[stage.id] || []"
      :column-total="columnTotals[stage.id] || 0"
      :formatted-column-total="formatCurrency(columnTotals[stage.id] || 0)"
      :get-sla-info="getSlaInfo"
      :get-channel-info="getChannelInfo"
      :get-source-info="getSourceInfo"
      :get-team-info="getTeamInfo"
      :get-deal-value="getDealValue"
      :get-deal-status="getDealStatus"
      :format-currency="formatCurrency"
      :format-date-time="formatDateTime"
      @drop-card="(cid, sid) => emit('move-stage', cid, sid)"
      @assign-me="cid => emit('assign-me', cid)"
      @resolve="cid => emit('resolve', cid)"
      @update-deal-value="(cid, val) => emit('update-deal-value', cid, val)"
      @update-deal-status="(cid, st) => emit('update-deal-status', cid, st)"
      @rename-lead="(cid, name) => emit('rename-lead', cid, name)"
      @delete-card="cid => emit('delete-card', cid)"
      @duplicate-card="conv => emit('duplicate-card', conv)"
      @edit-card="conv => emit('edit-card', conv)"
    />
  </main>
</template>

<style scoped>
.custom-scrollbar-x::-webkit-scrollbar {
  height: 8px;
}
.custom-scrollbar-x::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar-x::-webkit-scrollbar-thumb {
  background: rgba(150, 150, 150, 0.2);
  border-radius: 4px;
}
</style>
